const getKey = (key) => `danca:${key}`;

export const getStorage = (key) => localStorage.getItem(getKey(key));
export const removeStorage = (key) => localStorage.removeItem(getKey(key));
export const setStorage = (key, value) => localStorage.setItem(getKey(key), value);
